import { ArrowUp } from "lucide-react";
import { cn } from "@/lib/utils";

/** The composer's send control: a quiet ink disc, gray until there is something to send. */
export function SendButton(props: { label: string; disabled: boolean; className?: string }) {
  return (
    <button
      type="submit"
      aria-label={props.label}
      disabled={props.disabled}
      className={cn(
        "grid size-8 shrink-0 place-items-center rounded-full bg-action text-action-on outline-none transition-colors duration-(--duration-fast) hover:bg-action-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:bg-surface-selected disabled:text-fg-muted",
        props.className,
      )}
    >
      <ArrowUp aria-hidden="true" className="size-4" strokeWidth={2.25} />
    </button>
  );
}

/** The composer frame shared by home and the conversation: hairline, soft lift, round. */
export const COMPOSER_FRAME =
  "rounded-[26px] border border-line bg-surface-raised shadow-composer transition-[border-color] duration-(--duration-fast) focus-within:border-line-strong";
